import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useItem, useUpdateItem } from '@/hooks/item';
import { UpdateItemCommentModal } from '@/types/modal';
import { Textarea } from '@/components/molecules/common/Form';
import { ErrorModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: UpdateItemCommentModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const [comment, setComment] = useState('');
  const itemR = useItem(item.productId, false);
  const submitR = useUpdateItem(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.update_item_comment.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.update_item_comment.title')}
        onClose={onClose}
      />
    );
  }

  const body = (
    <div className={styles.updateItemComment}>
      <div className={styles.text1rem}>{t('modal.update_item_comment.description')}</div>
      <div className={styles.updateItemCommentTextarea}>
        <Textarea
          rows={6}
          value={comment}
          onChange={setComment}
        />
      </div>
    </div>
  );

  return (
    <StandardModal
      title={t('modal.update_item_comment.title')}
      modalName="update_item_comment"
      onClose={onClose}
      onSubmit={() => submitR.mutate({ internalComments: comment })}
      submittable={submitR.kind !== 'Loading' && comment !== ''}
      body={body}
      containerStyle={{ maxWidth: 650 }}
    />
  );
};

export default View;
